import { cleanCaption } from './cleanCaption';
import { customizeCaption } from './customizeCaption';

export const prepareCaption = (captionSettings: any, caption: string) => {
	const cleanedCaption = caption && cleanCaption(caption);
	const customizedCaption =
		cleanedCaption && customizeCaption(captionSettings, cleanedCaption);
	return customizedCaption;
};
